"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignRequests = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const uuid_1 = require("uuid");
const AuthoredEvidence = __importStar(require("../../composite/evidence/authored-evidence/authored-evidence"));
const evidence_1 = require("../../composite/evidence/evidence");
const empty_component_1 = require("../../utils/empty-component");
const signing_context_1 = require("../../providers/signing/signing-context");
const signing_types_1 = require("../../providers/signing/signing-types");
const sign_requests_actionbar_1 = require("./sign-requests-actionbar");
const sign_requests_columns_1 = require("./sign-requests-columns");
const sign_requests_fields_1 = require("./sign-requests-fields");
function SignRequests() {
    const intl = (0, react_intl_1.useIntl)();
    const { url, reportTag } = (0, react_1.useContext)(signing_context_1.SigningContext);
    if (!url || !reportTag) {
        throw new Error('Missing url or reportTag');
    }
    const evidence = AuthoredEvidence.useAuthoredEvidence({
        identifier: 'EAS_SIGNING_REQUEST',
        apiProps: {
            url,
        },
        tableProps: {
            columns: (0, sign_requests_columns_1.useColumns)(),
            tableName: intl.formatMessage({
                id: 'EAS_SIGNING_REQUEST_TABLE_TITLE',
                defaultMessage: 'Dokumenty k podepsání',
            }),
            reportTag,
        },
        detailProps: {
            GeneralFieldsComponent: empty_component_1.EmptyComponent,
            FieldsComponent: sign_requests_fields_1.RequestsFields,
            toolbarProps: {
                ActionBar: sign_requests_actionbar_1.SignRequestActionbar,
                title: intl.formatMessage({
                    id: 'EAS_SIGNING_REQUEST_DETAIL_TITLE',
                    defaultMessage: 'Dokument k podepsání',
                }),
            },
            initNewItem: () => ({
                id: (0, uuid_1.v4)(),
                state: signing_types_1.SignRequestState.NEW,
            }),
        },
    });
    return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
}
exports.SignRequests = SignRequests;
//# sourceMappingURL=sign-requests.js.map